const cardList = document.querySelector('.card-list');

if (cardList) {
  const cardListSlider = document.querySelectorAll('[data-slider="card-list__slider"]');

  const cardListOptions = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  cardListSlider.forEach((el) => {
    const parentElem = el.closest('.card-list');

    const arrowLeft = parentElem.querySelector('.swiper-button-prev');
    const arrowRight = parentElem.querySelector('.swiper-button-next');

    cardListOptions.navigation.prevEl = arrowLeft;
    cardListOptions.navigation.nextEl = arrowRight;

    new Swiper(el, cardListOptions);
  });

  // Filter and Pagination via ajax

  const axiosGetCardList = async (parent, slug, pageNumber) => {
    const action = parent.querySelector('[data-action]').value;
    const cardType = parent.getAttribute('data-card-type');
    const initialCategoryData = parent.querySelector('[data-initial]').value;
    const listInner = parent.querySelector('.card-list__inner');
    const noResultElem = parent.querySelector('.card-list__not-found');
    const cardListFooter = parent.querySelector('.card-list__footer');

    const formDataInput = {
      action,
      slug,
      cardType,
      initialCategoryData,
      pageNumber,
      filteredCategory: slug,
      nonce: await getNonceForAction(action),
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      listInner.innerHTML = '';

      if (listInner && data.data.html_list) {
        listInner.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      if (cardListFooter && data.data.html_pagination) {
        cardListFooter.innerHTML = data.data.html_pagination;
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['filteredCategory', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
      cardList.scrollIntoView();
    } catch (err) {
      console.error(err);
    }
  };

  // Filter click
  attachEvent('.card-list .card-list__filter-link', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.card-list');
    const dataSlug = ev.target.getAttribute('data-slug');

    parent.querySelector('.card-list__filter-link.is-active').classList.remove('is-active');
    ev.target.classList.add('is-active');

    axiosGetCardList(parent, dataSlug, 1);
  });

  // Pagination
  attachEvent('.card-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.card-list');
    const activeCategory = parent.querySelector('.card-list__filter-link.is-active');
    const dataSlug = activeCategory?.getAttribute('data-slug');
    const pageNumber = ev.target.dataset.page;

    axiosGetCardList(parent, dataSlug, pageNumber);
  });
}
